export const themeListOfTrends = {
    singleSort: '*You can sort a single column by clicking its header.',
    rank: 'Rank',
    category: 'Category',
    themeName: 'Theme Name',
    companyCount: 'Number of companies',
    patentCount: 'Number of Patent Applications',
    growthRatePatentCount: 'Patent application growth rate',
    investmentAmount: 'Total investment amount',
    growthRateInvestmentAmount: 'Investment growth rate',
    businessAmount: 'Business Scale',
    analyzedThemeButton: 'Analyze the selected theme',
    defaultSortDescription:
        'By default, themes are sorted by vector similarity ranking. Clicking another column will sort the table by that column.\nTo return to the vector similarity ranking, please enter the keyword again and run the search again.'
}
